export default __webpack_public_path__ + "static/media/pg.257eb7ff.svg";